import React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn, buildModuleRoute } from 'modules/core/lib/react-router'

const SettingsPage = React.lazy(() => import('modules/personal_settings/pages/SettingsPage'))

export const personalSettingsRoutes: NavigationRoutesFn = (navigation) => [
  buildModuleRoute({
    path: navigation.personalSettings.path,
    handle: {
      module: 'settings',
      moduleName: () => i18n.t('personal_settings.personal_settings'),
      meta: () => ({
        title: i18n.t('personal_settings.personal_settings'),
      }),
    },
    element: <SettingsPage />,
  }),
]
